import React from 'react';

import List from '@sv-support-sdk/ui-components/src/components/Lists/List';

import NoticeDot from '../components/Feedback/NoticeDot';
import Badge from '../components/Feedback/Badge';

import { $l } from '../locales';
import { ITicketSelector } from '../store/selectors/tickets';
import { ITableColumn } from '../types/commonTypes';

export const ticketListColumns: ITableColumn<ITicketSelector>[] = [
  {
    name: $l('TICKETS.TICKET_LIST_DATE'),
    key: 'dateAndTime',
    cell: ({ createdAt, unread }) => (
      <List align="center" direction="row" isWrapped>
        {unread ? <NoticeDot placement="left" /> : null}
        <div>{createdAt}</div>
      </List>
    ),
    textColor: 'grey',
  },
  { name: $l('TICKETS.TICKET_LIST_ID'), key: 'id', cell: ({ id }) => id },
  {
    name: $l('TICKETS.TICKET_LIST_SUBJECT'),
    key: 'subject',
    cell: ({ subject }) => subject,
    width: '50%',
  },
  {
    name: $l('TICKETS.TICKET_LIST_STATUS'),
    key: 'status',
    cell: ({ status }) => <Badge color={status.color}>{status.children}</Badge>,
  },
];
